import { typeActionCreator, valueActionCreator } from '../action_creators';

export const CUSTOM_FIELDS_CREATE = 'CUSTOM_FIELDS_CREATE';
export const CUSTOM_FIELDS_REMOVE = 'CUSTOM_FIELDS_REMOVE';

export const customFieldsCreateAction = typeActionCreator(CUSTOM_FIELDS_CREATE);
export const customFieldsRemoveAction = valueActionCreator<number | string>(CUSTOM_FIELDS_REMOVE);
